/**
 * ChessRogue - Main Entry Point
 * Roguelike Chess Game for Mobile
 */

import Phaser from 'phaser';
import gameConfig from './config/GameConfig';
import { FONT } from './constants/Theme';

// Make Outfit the default font for every text object. Phaser defaults to
// 'Courier' and does not expose a global font config, so we wrap the text
// factory once: any add.text() call that doesn't set its own fontFamily gets
// the UI font, while explicit families (piece glyphs, debug monospace) win.
const factory = Phaser.GameObjects.GameObjectFactory.prototype as any;
const originalText = factory.text;
factory.text = function (x: number, y: number, text: any, style: any) {
  const merged = style ? { ...style } : {};
  if (!merged.fontFamily) merged.fontFamily = FONT;
  return originalText.call(this, x, y, text, merged);
};

// Create Phaser game instance
const game = new Phaser.Game(gameConfig);

// Handle window visibility changes (mobile-friendly)
document.addEventListener('visibilitychange', () => {
  if (document.hidden) {
    game.pause();
  } else {
    game.resume();
  }
});

// Handle window focus/blur
window.addEventListener('blur', () => {
  game.pause();
});

window.addEventListener('focus', () => {
  game.resume();
});

// Export for debugging
(window as any).game = game;

// Vite HMR: destroy old game before module re-executes
if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    game.destroy(true);
  });
}

export default game;
